export const strict = false;
export const type = 'white-label';

export const GET = 'GET';
export const WHITE_LABEL = 'WHITE_LABEL';
export const ENABLED = 'ENABLED';
const SET_WHITE_LABEL = 'SET_WHITE_LABEL';

export const state = () => ({
  data: {}
});

export const actions = {
  async [GET]({ getters, state, commit }, { slug }) {
    const response = await this.$axios.$get(
      'api/v1/appointments/white_label',
      { params: { slug } }
    );

    commit(SET_WHITE_LABEL, response);
  }
};

export const mutations = {
  [SET_WHITE_LABEL](state, { data }) {
    state.data = data;
  }
};

export const getters = {
  [WHITE_LABEL](state, getters) {
    return state.data.attributes
      ? { ...state.data.attributes, id: state.data.id }
      : {};
  },
  [ENABLED](state, getters) {
    const data = getters[WHITE_LABEL];
    // eslint-disable-next-line no-unused-vars
    const { id, ...filtered } = data;

    const present = Object.values(filtered).some(v => (v !== null && v !== ''));

    return present;
  }
};
